import { API_URL } from "../config/api";

export interface SearchResponse {
  query: string;
  total_results: number;
  results: {
    projects?: SearchResult[];
    people?: SearchResult[];
    assets?: SearchResult[];
    warranties?: SearchResult[];
    tasks?: SearchResult[];
    documents?: SearchResult[];
    locations?: SearchResult[];
    manufacturers?: SearchResult[];
  };
}

export interface SearchResult {
  id: string;
  name: string;
  description?: string;
  type: string;
  url: string;
  company?: string;
  role?: string;
  uploadedBy?: string;
  uploadedAt?: string;
  size?: number;
}





/**
 * Global search across all data types
 * @param {string} token - The authorization token
 * @param {string} query - Search query
 * @param {number} limit - Maximum number of results
 * @param {number} offset - Offset for pagination
 * @returns {Promise<SearchResponse>} Search results
 */
export const globalSearch = async (
  token: string,
  query: string,
  limit: number = 20,
  offset: number = 0
): Promise<SearchResponse> => {
  try {
    const searchParams = new URLSearchParams({
      q: query,
      limit: limit.toString(),
      offset: offset.toString()
    });

    const response = await fetch(`${API_URL}/search?${searchParams.toString()}`, {
      headers: {
        'content-type': 'application/json',
        'authorization': 'Bearer ' + token
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data: SearchResponse = await response.json();
    return data;
  } catch (error: any) {
    console.error('Error in global search:', error);
    throw new Error(error.message || 'Failed to perform search');
  }
}; 